import Router from 'vue-router'
import SigninPage from '@/pages/signin/signin.page'

import HomePage from '@/pages/home/home.page'

import NewRequestPage from '@/pages/monitors/new/new.page'
import RequestWinners from '@/pages/monitors/winners/winners.page'
import RequestWinnersV2 from '@/pages/monitors/winners-v2/winners-v2.page'
import Campaigns from "@/pages/campaigns/index.page";
import CampaignOrders from "./pages/campaigns/orders/index.page";
import MonitorsPage from '@/pages/monitors/monitors.page'
import RequestDetailsPage from '@/pages/monitors/details/details.page'
import OrderInfo from '@/pages/order-info/details.page'
import RequestPage from '@/pages/request/index.page'
import SubRequestPage from '@/pages/subrequest/index.page'
import RequestMatrixDetailsPage from '@/pages/monitors/details/details-matrix.page'
import priceManager from '@/pages/monitors/priceManager.vue'
import RequestProvidersWithoutOffer from '@/pages/monitors/providers/without-offer.page'
import DirectRequest from './pages/orders/show.page'
import Divegent from './pages/orders/DivergentPage.vue'
import NotFoundPage from '@/pages/errors/not-found.page'
import SellersPage from '@/pages/sellers/sellers.page'
import ProductsPage from '@/pages/products/products.page'
import ProductsV2Page from '@/pages/products-v2/products-v2.page.vue'
import SellersV2Page from '@/pages/sellers-v2/sellers-v2.page.vue'
import ReportsPage from '@/pages/reports/reports.page'
import SettingsPage from '@/pages/user/settings.page'
import ResumeOrder from '@/pages/orderResume/OrderResumeView.vue'
import ExplorePage from '@/pages/maps/explore.page'
import DashboardV2Page from '@/pages/dashboard-v2/dashboard-v2.page.vue'
import HighlightsPage from '@/pages/products/highlights/index.page'
import CompraDireta from './components/cliente/relatorios/CompraDireta'
import HomePageV2 from '@/pages/HomePage/HomePage.vue'
import inicio from '@/pages/inicio/inicio.vue'
import PublicOffer from '@/pages/PublicPage/PublicOffer.vue'
import ClientSuplier from '@/pages/monitors/ClientSuplier.vue'
import FoodServiceBrands from '@/pages/products/FoodServiceBrands.vue'
import Repurchase from '@/pages/repurchase/repurchase.vue'
import Help from '@/pages/help/help.vue';
import { clear_features, ensure_features, has_feature, PRODUCTS_V2, REQUESTS_V2, REQUISITIONS, SELLERS_V2, VISITS, WINNERS_V2 } from '@/helpers/features';

let router = new Router({
    mode: "history",
    hash: false,
    routes: [
        { path: "/", name: "home", component: HomePage },
        { path: "/inicio", name: "Inicio", component: inicio },
        { path: "/Login/", name: "login", component: SigninPage },
        { path: "/ofertas", name: "campaigns-index", component: Campaigns },
        { path: "/explorar", name: "explore", component: ExplorePage },
        { path: "/destaques", name: "highlights", component: HighlightsPage },
        { path: "/ofertas/pedidos", name: "campaign-orders-index", component: CampaignOrders },
        { path: "/cliente/", name: "cliente", component: HomePage },
        { path: "/cotacoes/:id", name: "request", component: RequestPage, props: true },
        { path: "/cotacoes/:id/loja/:store_id/vendedor/:seller_id", name: "subrequest", component: SubRequestPage, props: true },
        {
            path: "/cliente/cotacao/nova",
            name: "cliente-new-request",
            component: NewRequestPage
        },
        {
            path: "/cliente/monitores/:tab",
            name: "monitors-page",
            component: MonitorsPage,
            props: true,
            // Abas liberadas por recurso: sem ele, cai na aba antiga.
            meta: { tabFeatures: { 'cotacoes-v2': REQUESTS_V2 } },
        },
        {
            path: "/cliente/monitores/ressuprimento/edit",
            name: "EditSpecialResuplyPage",
            component: () => import('@/pages/monitors/EditSpecialResuply'),
            props: true
        },
        {
            path: "/cliente/monitores/ressuprimento/editar/:id",
            name: "Ressuprimento-Editar",
            component: () => import('@/pages/monitors/tabs/_resupplyEdit.tab.vue'),
            props: true
        },
        {
            path: "/cliente/monitores/ressuprimento/editar/:id/produto/:productId",
            name: "Ressuprimento-Editar-Produto",
            component: () => import('@/pages/products-v2/product.page.vue'),
            props: (route) => ({ id: route.params.id, productId: route.params.productId })
        },
        {
            path: "/cliente/recompra",
            name: "repurchase-page",
            component: Repurchase,
        },
        {
            path: "/cliente/fornecedor",
            name: "monitors-client-suplier",
            component: ClientSuplier
        },
        {
            path: "/cliente/monitores/vencedores/:id",
            name: "cliente-monitores-vencedores",
            component: RequestWinners
        },
        {
            path: "/cliente/monitores/vencedores-v2/:id",
            name: "cliente-monitores-vencedores-v2",
            component: RequestWinnersV2,
            props: true,
            meta: { feature: WINNERS_V2 },
        },
        {
            path: "/cliente/monitores/pedidos/:id",
            name: "cliente-monitores-pedido",
            component: DirectRequest
        },
        {
            path: "/cliente/vencedores/:id/vendedor/:sellerid/loja/:sid/fornecedor/:providerid/divergent",
            name: "cliente-monitores-divergent",
            component: Divegent
        },
        {
            path:
                "/cliente/vencedores/:id/vendedor/:sellerid/loja/:sid/fornecedor/:providerid/:cnpj?",
            name: "lancamento-cliente-monitores-vencedores",
            component: RequestDetailsPage,
            props: true
        },
        {
            path: "/order-info/:id/vendedor/:sellerid/loja/:sid/fornecedor/:providerid/:cnpj?",
            name: "order-info",
            component: OrderInfo,
            props: true
        },
        {
            path:
                "/cliente/vencedores/:id/vendedor/:sellerid/fornecedor/:providerid",
            name: "request-matrix-overview",
            component: RequestMatrixDetailsPage,
            props: true
        },
        {
            path:
                "/cliente/vencedores/:id/vendedor/:sellerid/fornecedor/:providerid/price-manager",
            name: "requestPriceManager",
            component: priceManager,
            props: true
        },
        {
            path: "/cliente/monitores/:id/naodigitados",
            name: "nao-digitados-cotacao",
            component: RequestProvidersWithoutOffer
        },
        {
            // Antigo /relatorios com abas: cada relatório virou uma página do
            // submenu Relatórios. Mantém links antigos e o push do monitor de
            // cotações ({ name: "relatorios", params: { tab: "analise", request_id } }).
            path: "/relatorios",
            name: "relatorios",
            redirect: (to) =>
                to.params.tab === "analise"
                    ? { name: "relatorios-analise-de-preco", query: to.params.request_id ? { cotacao: to.params.request_id } : {} }
                    : { name: "relatorios-compras" }
        },
        {
            path: "/relatorios/compras",
            name: "relatorios-compras",
            component: ReportsPage,
            props: { report: "compras" }
        },
        {
            path: "/relatorios/ordens-de-compra",
            name: "relatorios-ordens-de-compra",
            component: ReportsPage,
            props: { report: "ordens" }
        },
        {
            path: "/relatorios/whatsapp",
            name: "relatorios-whatsapp",
            component: ReportsPage,
            props: { report: "whatsapp" }
        },
        {
            // ?cotacao= no lugar do params de antes: sobrevive ao recarregar a página
            path: "/relatorios/analise-de-preco",
            name: "relatorios-analise-de-preco",
            component: ReportsPage,
            props: (route) => ({
                report: "preco",
                request_id: route.query.cotacao ? Number(route.query.cotacao) : undefined
            })
        },
        {
            path: "/fornecedores/",
            name: "sellers",
            component: SellersPage
        },
        {
            path: "/fornecedores-v2/",
            name: "sellers-v2",
            component: SellersV2Page,
            // Sem o recurso, a tela antiga.
            meta: { feature: SELLERS_V2, featureFallback: { name: 'sellers' } },
        },
        {
            path: "/produtos-v2/",
            name: "products-v2",
            component: ProductsV2Page,
            meta: { feature: PRODUCTS_V2, featureFallback: { name: 'products' } },
        },
        {
            path: "/produtos-v2/produto/:productId",
            name: "products-v2-product",
            component: () => import('@/pages/products-v2/product.page.vue'),
            props: (route) => ({ id: route.params.id, productId: route.params.productId }),
            meta: { feature: PRODUCTS_V2, featureFallback: { name: 'products' } },
        },
        {
            path: "/produtos/marcas",
            name: "productsBrands",
            component: FoodServiceBrands
        },
        {
            path: "/produtos/:tab?",
            name: "products",
            component: ProductsPage
        },
        {
            path: "/compradireta/",
            name: "Compra-Direta",
            component: CompraDireta
        },
        {
            path: "/configuracoes/:tab?",
            name: "user-settings",
            component: SettingsPage
        },
        {
            path: "/resume-order/",
            name: 'resumeOrder',
            component: ResumeOrder
        },
        {
            path: "/dashboard/",
            name: 'Dashboard',
            // O dashboard antigo (DashboardPage) está descontinuado: /dashboard/
            // continua sendo a URL divulgada — sidebar, menu mobile e início
            // apontam para ela — mas renderiza a versão nova. /dashboard-v2/
            // segue existindo para quem já tem o link salvo.
            component: DashboardV2Page
        },
        {
            path: "/dashboard-v2/",
            name: 'DashboardV2',
            component: DashboardV2Page
        },
        {
            path: "/home-page/",
            name: 'HomePage',
            component: HomePageV2
        },
        {
            path: "/club-de-ofertas/:filter?",
            name: 'PublicOffers',
            component: PublicOffer
        },
        {
            path: "/visitas",
            name: "visits",
            component: () => import('@/pages/visits/visits.page.vue'),
            meta: { feature: VISITS, featureFallback: { name: "monitors-page", params: { tab: "cotacoes" } } },
        },
        {
            path: "/visitas/:id",
            name: "visits-detail",
            component: () => import('@/pages/visits/visit.page.vue'),
            props: true,
            meta: { feature: VISITS, featureFallback: { name: "monitors-page", params: { tab: "cotacoes" } } },
        },
        {
            path: "/requisicoes",
            name: "seller-orders",
            component: () => import('@/pages/seller-orders/seller-orders.page.vue'),
            meta: { feature: REQUISITIONS, featureFallback: { name: "monitors-page", params: { tab: "cotacoes" } } },
        },
        {
            path: "/requisicoes/:id",
            name: "seller-orders-detail",
            component: () => import('@/pages/seller-orders/seller-order.page.vue'),
            props: true,
            meta: { feature: REQUISITIONS, featureFallback: { name: "monitors-page", params: { tab: "cotacoes" } } },
        },
        {
            path: "404",
            name: "404",
            component: NotFoundPage
        },
        {
            path: "*",
            redirect: { name: "404" }
        },
        {
            path: "/ajuda",
            name: "Help",
            component: Help
        }
    ]
});

import { store } from '@/store/store'
router.beforeEach(async (to, from, next) => {
    window.scrollTo(0, 0)
    if (to.name == 'login' || to.name == 'PublicOffers') {
        next()
    } else {
        if (to.query && to.query.token) {
            localStorage.setItem('token', to.query.token)
            // Entrada por link (?token=): as permissoes em cache sao do login
            // anterior e, num navegador novo, nem existem — sem elas varias
            // telas quebram em this.perms.forEach. Busca as do token novo.
            localStorage.removeItem('perms')
            await store.dispatch('user/load_perms').catch(() => {})
            // The token can change when the app is opened from a new access
            // link. Never reuse entitlements resolved for the previous user.
            clear_features()
        }
        store.dispatch('user/load_user')

        // Resolved for every navigation, not only routes carrying
        // meta.feature: components read the cache synchronously (feature.mixin)
        // including inside data(), which runs before mounted. One request per
        // session — ensure_features() short-circuits once it is cached.
        await ensure_features()

        const tabFeature = to.meta && to.meta.tabFeatures && to.meta.tabFeatures[to.params.tab]
        if (tabFeature && !has_feature(tabFeature)) {
            next({ name: 'monitors-page', params: { tab: 'cotacoes' }, replace: true })
            return
        }

        // Com a tela nova de cotações liberada, a antiga deixa de ser destino:
        // login, breadcrumbs e redirects antigos apontam para /cotacoes.
        if (to.name === 'monitors-page' && to.params.tab === 'cotacoes' && has_feature(REQUESTS_V2)) {
            next({ name: 'monitors-page', params: { tab: 'cotacoes-v2' }, query: to.query, replace: true })
            return
        }

        if (to.meta && to.meta.feature && !has_feature(to.meta.feature)) {
            const fallback = to.meta.featureFallback || { name: 'cliente-monitores-vencedores', params: { id: to.params.id } }
            next({ ...fallback, replace: true })
            return
        }

        next()
    }
})

export default router;
